import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/styles';


const useStyles = makeStyles(() => ({
  button: {
    minWidth: 24,
    width: 24,
    top: 10,
    marginLeft: 10,
  },
  formControl: {
    display: 'inline-block',
    marginTop: 10,
  },
}));

const DurationTextField = ({
   input: { name, value, onChange },
   meta: { touched, error },
   floatingLabelText,
}) => {
  const classes = useStyles();

  /**
   * The field itself is floating point, but it needs to be rendered as HH:mm
   * datetime.
   */
  const fvalue = Number(value);
  const dp = '00';
  let dh = parseInt(fvalue || 0.0, 10);
  let dm = parseInt(((fvalue || 0.0) - dh) * 60, 10);

  dh = dh.toString();
  dm = dm.toString();
  dh = dp.substring(0, dp.length - dh.length) + dh;
  dm = dp.substring(0, dp.length - dm.length) + dm;

  const displayValue = dh + ':' + dm;

  return (
    <FormControl error={touched && error} className={classes.formControl}>
      <TextField
        error={touched && error}
        name={name}
        label={floatingLabelText}
        style={{ width: 50 }}
        value={displayValue}
      />

      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          let newValue = Number(value) - 0.5;

          if (newValue < 0) newValue = 0;

          onChange(newValue.toString());
        }}
        className={classes.button}
      >
        -
      </Button>

      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          let newValue = Number(value) + 0.5;

          onChange(newValue.toString());
        }}
        className={classes.button}
      >
        +
      </Button>

      {(touched && error) && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

DurationTextField.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any,
  }).isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool.isRequired,
    warning: PropTypes.string,
  }).isRequired,
  floatingLabelText: PropTypes.string.isRequired,
};

export default DurationTextField;
